export default "__VITE_ASSET__BlouHgIp__"